import axios from "axios"
import React from "react"
import SVG from "react-inlinesvg"
import * as Modal from "react-modal"
import YouTubePlayer from "react-player/lib/players/YouTube"
import Image from "../../../components/lazy-loaders/image"
import youtubeTimestamp from "../../../helpers/youtubeTimestamp"
import styles from "./video.module.scss"

const crossIcon = require("../../../assets/images/cross-icon.svg")

interface Props {
  posterImage: string
  videoId: string
  highlightColour: string
}

interface State {
  videoModalOpen: boolean
  videoLength: string
}

declare const YOUTUBE_API_KEY: string

class Video extends React.Component<Props> {
  state: State

  constructor(props: Props) {
    super(props)
    Modal.setAppElement("#___gatsby")
    this.state = {
      videoModalOpen: false,
      videoLength: "",
    }
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal() {
    const { PreventScrolling, ReEnableScrolling } = require("prevent-scrolling")
    this.setState({ videoModalOpen: !this.state.videoModalOpen }, () => {
      const scrollableElement: any = document.querySelector(
        ".ReactModal__Content"
      )
      this.state.videoModalOpen
        ? PreventScrolling(scrollableElement)
        : ReEnableScrolling()
    })
  }

  getTimestamp() {
    const url = `https://www.googleapis.com/youtube/v3/videos?id=${
      this.props.videoId
    }&part=contentDetails&key=${YOUTUBE_API_KEY}`
    axios
      .get(url)
      .then((response) => {
        if (response.data.items.length) {
          const details = response.data.items[0].contentDetails
          this.setState({ videoLength: youtubeTimestamp(details.duration) })
        }
      })
      .catch((error) => {
        // Silently fail. Just won't show any text
      })
  }

  componentDidMount() {
    this.getTimestamp()
  }

  render() {
    const { posterImage, highlightColour } = this.props

    return (
      <div className={styles.video}>
        <button
          className="play-button"
          style={{ background: highlightColour }}
          onClick={this.toggleModal}
        >
          Watch
        </button>
        <div
          className={styles.posterImage}
          data-hover="&#9658;"
          data-hover-background={highlightColour}
        >
          <Image
            image={posterImage}
            colour={highlightColour}
            ratio={0.5625}
            responsive={true}
            widths={[768, 1024, 1600, 2000]}
          />
          <img src={posterImage} onClick={this.toggleModal} />
        </div>
        <div className={styles.timestamp}>
          <span className="display1">{this.state.videoLength}</span>
        </div>
        <Modal
          isOpen={this.state.videoModalOpen}
          className={styles.modal}
          overlayClassName={styles.modalContent}
        >
          <div className={styles.videoContainer}>
            <button
              className={styles.modalCloseButton}
              onClick={this.toggleModal}
            >
              <SVG src={crossIcon} className={styles.closeButtonIcon} />
            </button>
            <YouTubePlayer
              height="100%"
              width="100%"
              url={`https://www.youtube.com/watch?v=${this.props.videoId}`}
              playing={true}
              config={{
                youtube: {
                  playerVars: {
                    controls: 0,
                  },
                },
              }}
            />
          </div>
        </Modal>
      </div>
    )
  }
}

export default Video
